var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"p-1 mr-2",attrs:{"dark":"","small":"","color":"#FFCA28","loading":_vm.loading},on:{"click":_vm.getCount}},[_vm._t("audience-button-title",null,{"title":_vm.title})],2)}
var staticRenderFns = []

export { render, staticRenderFns }